<template>
  <div class="">
    <UploadPDF></UploadPDF>
  </div>
</template>

<script>
export default {
  components: {
    ...require('../../kit.js').default
  }
}
</script>

<style>

</style>
